import { empty as emptyFilter } from '@utils'

const platform = process.env.CHOOSE_PROJECT_MODAL?.platform

export const getColumns = () => {
    switch (platform) {
        case 'benxi':
            return [
                {
                    title: '工程名称',
                    dataIndex: 'projectName',
                    width: 250
                },
                {
                    title: '项目地址',
                    dataIndex: 'projectDetailAddress',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '施工单位名称',
                    dataIndex: 'generalConstructionContractingName',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '施工单位统一社会信用代码',
                    dataIndex: 'socialCreditCode',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '建设单位',
                    dataIndex: 'constructionUnitName',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    key: 'action',
                    title: '操作',
                    width: 100,
                    fixed: 'right',
                    scopedSlots: {
                        customRender: 'action'
                    }
                }
            ]
        default:
            return [
                {
                    title: '工程名称',
                    dataIndex: 'projectName',
                    width: 250
                },
                {
                    title: '统一项目编号',
                    dataIndex: 'projectCode',
                    width: 200,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '施工许可证编号',
                    dataIndex: 'constructionPermitNo',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '项目地点',
                    dataIndex: 'projectDetailAddress',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '施工单位名称',
                    dataIndex: 'generalConstructionContractingName',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    title: '建设单位',
                    dataIndex: 'constructionUnitName',
                    width: 250,
                    customRender: val => emptyFilter(val)
                },
                {
                    key: 'action',
                    title: '操作',
                    fixed: 'right',
                    width: 100,
                    scopedSlots: {
                        customRender: 'action'
                    }
                }
            ]
    }
}
